import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  transform(array: any[], key: string, reverse?: boolean): any[] {
    if (!array) {
      return array;
    }
    let keys;
    if (key.indexOf('.') > 0) {
      keys = key.split('.');
    }

    array.sort((a: any, b: any) => {
      if (!keys) {
        if (a[key] < b[key] || a[key] === undefined || a[key] === null) {
          return -1;
        } else if (a[key] > b[key] || b[key] === undefined || b[key] === null) {
          return 1;
        }
      } else if (a[keys[0]]) {
        if (a[keys[0]][keys[1]] < b[keys[0]][keys[1]] || a[keys[0]][keys[1]] === undefined || a[keys[0]][keys[1]] === null) {
          return -1;
        } else if (a[keys[0]][keys[1]] > b[keys[0]][keys[1]] || b[keys[0]][keys[1]] === undefined || b[keys[0]][keys[1]] === null) {
          return 1;
        }
      }

      return 0;
    });

    if (reverse) {
      array = array.reverse();
    }

    return array;
  }
}

@NgModule({
  imports: [],
  declarations: [SortByPipe],
  exports: [SortByPipe]
})
export class SortByPipeModule { }
